import React, { PropTypes } from 'react';
import cx from 'classnames';

const starClass = isStared =>
  cx('star icon', {
    active: isStared,
    empty: !isStared,
  });

const MessagesHeader = ({ user, isStared, onStar }) => (
  <div className="ui segment">
    <div className="header">
      <span>
        <i className={starClass(isStared)} onClick={onStar} />
      </span>
      {user.name || user.email}
    </div>
  </div>
);

MessagesHeader.propTypes = {
  user: PropTypes.object.isRequired,
  isStared: PropTypes.bool.isRequired,
  onStar: PropTypes.func.isRequired,
};

export default MessagesHeader;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/MessagesHeader.js